import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const CubicCapacity = (props) => {
  return (
    <FormGroup controlId="cubicCap">
      <Col componentClass={ControlLabel} sm={5}>
        Cubic Capacity
      </Col>
    <Col sm={7}>
        <FormControl type="number" step="1" max="99999" autoComplete="off"
          value={props.cubicCap} onChange={props.handleChangeCubicCap} />
    </Col>
    </FormGroup>
  )
}

CubicCapacity.propTypes = {
  cubicCap: PropTypes.number,
  handleChangeCubicCap: PropTypes.func
};

export default CubicCapacity;



// WEBPACK FOOTER //
// ./src/app/components/cubicCapacity/CubicCapacity.js